import {FC, useState, createContext, useContext, Dispatch, SetStateAction} from 'react'

import {WithChildren} from '../../../_metronic/helpers'

type StakeholdersContextProps = {
  founderPromoterFilter: boolean
  setFounderPromoterFilter: Dispatch<SetStateAction<boolean>>
  selectedFounderPromoterTypeFilter: string
  setSelectedFounderPromoterTypeFilter: Dispatch<SetStateAction<string>>
  selectedFounderPromoterSortTypeFilter: string
  setSelectedFounderPromoterSortTypeFilter: Dispatch<SetStateAction<string>>
  teamManagementFilter: boolean
  setTeamManagementFilter: Dispatch<SetStateAction<boolean>>
  selectedTeamManagementTypeFilter: string
  setSelectedTeamManagementTypeFilter: Dispatch<SetStateAction<string>>
  boardMemberFilter: boolean
  setBoardMemberFilter: Dispatch<SetStateAction<boolean>>
  selectedBoardMemberTypeFilter: string
  setSelectedBoardMemberTypeFilter: Dispatch<SetStateAction<string>>
  legalCompilanceFilter: boolean
  setLegalCompilanceFilter: Dispatch<SetStateAction<boolean>> // Typo fix: was setlegalCompilanceFilter
  selectedLegalCompilanceTypeFilter: string
  setSelectedLegalCompilanceTypeFilter: Dispatch<SetStateAction<string>> // Typo fix: was selectedlegalCompilanceTypeFilter
  selectedLegalCompilanceSortTypeFilter: string
  setSelectedLegalCompilanceSortTypeFilter: Dispatch<SetStateAction<string>> // Typo fix: was selectedlegalCompilanceSortTypeFilter
  financeAccountsFilter: boolean
  setFinanceAccountsFilter: Dispatch<SetStateAction<boolean>>
  selectedFinanceAccountsTypeFilter: string
  setSelectedFinanceAccountsTypeFilter: Dispatch<SetStateAction<string>>
  selectedFinanceAccountsSortTypeFilter: string
  setSelectedFinanceAccountsSortTypeFilter: Dispatch<SetStateAction<string>>
  advisorsMentorsFilter: boolean
  setAdvisorsMentorsFilter: Dispatch<SetStateAction<boolean>>
  selectedAdvisorsMentorsTypeFilter: string
  setSelectedAdvisorsMentorsTypeFilter: Dispatch<SetStateAction<string>>
  selectedAdvisorsMentorsSortTypeFilter: string
  setSelectedAdvisorsMentorsSortTypeFilter: Dispatch<SetStateAction<string>>
  shareSecurityClassesSortFilter: boolean
  setShareSecurityClassesSortFilter: Dispatch<SetStateAction<boolean>>
  selectedShareSecurityClassesSortFilter: string
  setSelectedShareSecurityClassesSortFilter: Dispatch<SetStateAction<string>>

  convertibleSecurityClassesFilter: boolean
  setConvertibleSecurityClassesFilter: Dispatch<SetStateAction<boolean>>

  selectedConvertibleSecurityClassesSortFilter: string
  setSelectedConvertibleSecurityClassesSortFilter: Dispatch<SetStateAction<string>>

  selectedConvertibleSecurityClassesRateFilter: string
  setSelectedConvertibleSecurityClassesRateFilter: Dispatch<SetStateAction<string>>

  warrantSecurityClassesFilter: boolean
  setWarrantSecurityClassesFilter: Dispatch<SetStateAction<boolean>>

  selectedWarrantSecurityClassesSortFilter: string
  setSelectedWarrantSecurityClassesSortFilter: Dispatch<SetStateAction<string>>

  complianceMeetingFilter: boolean
  setComplianceMeetingFilter: Dispatch<SetStateAction<boolean>> // Typo fix: was setlegalCompilanceFilter
  selectedComplianceMeetingTypeFilter: string
  setSelectedComplianceMeetingTypeFilter: Dispatch<SetStateAction<string>> // Typo fix: was selectedlegalCompilanceTypeFilter
  selectedComplianceMeetingDateFilter: string
  setSelectedComplianceMeetingDateFilter: Dispatch<SetStateAction<string>> // Typo fix: was selectedlegalCompilanceSortTypeFilter

  shareTransactionFilter: boolean
  setShareTransactionFilter: Dispatch<SetStateAction<boolean>>
  selectedShareTransactionSortFilter: string
  setSelectedShareTransactionSortFilter: Dispatch<SetStateAction<string>>
  selectedShareTransactionDateFilter: string
  setSelectedShareTransactionDateFilter: Dispatch<SetStateAction<string>>

  convertibleTransactionFilter: boolean
  setConvertibleTransactionFilter: Dispatch<SetStateAction<boolean>>
  selectedConvertibleTransactionSortFilter: string
  setSelectedConvertibleTransactionSortFilter: Dispatch<SetStateAction<string>>
  selectedConvertibleTransactionDateFilter: string
  setSelectedConvertibleTransactionDateFilter: Dispatch<SetStateAction<string>>

  warrantTransactionFilter: boolean
  setWarrantTransactionFilter: Dispatch<SetStateAction<boolean>>
  selectedWarrantTransactionSortFilter: string
  setSelectedWarrantTransactionSortFilter: Dispatch<SetStateAction<string>>
  selectedWarrantTransactionDateFilter: string
  setSelectedWarrantTransactionDateFilter: Dispatch<SetStateAction<string>>

  buybackTransactionFilter: boolean
  setBuybackTransactionFilter: Dispatch<SetStateAction<boolean>>
  selectedBuybackTransactionSortFilter: string
  setSelectedBuybackTransactionSortFilter: Dispatch<SetStateAction<string>>
  selectedBuybackTransactionDateFilter: string
  setSelectedBuybackTransactionDateFilter: Dispatch<SetStateAction<string>>

  transferTransactionFilter: boolean
  setTransferTransactionFilter: Dispatch<SetStateAction<boolean>>
  selectedTransferTransactionSortFilter: string
  setSelectedTransferTransactionSortFilter: Dispatch<SetStateAction<string>>
  selectedTransferTransactionDateFilter: string
  setSelectedTransferTransactionDateFilter: Dispatch<SetStateAction<string>>

  createdShareClassFromOtherClasses: string | undefined
  setCreatedShareClassFromOtherClasses: Dispatch<SetStateAction<string | undefined>>

  createdShareClassEditConvertibleClassId: string | undefined
  setCreatedShareClassEditConvertibleClassId: Dispatch<SetStateAction<string | undefined>>

  createdShareClassEditWarrantClassId: string | undefined
  setCreatedShareClassEditWarrantClassId: Dispatch<SetStateAction<string | undefined>>

  createdConvetibleClassFromOtherTransaction: string | undefined
  setCreatedConvetibleClassFromOtherTransaction: Dispatch<SetStateAction<string | undefined>>

  createdWarrantClassFromOtherTransaction: string | undefined
  setCreatedWarrantClassFromOtherTransaction: Dispatch<SetStateAction<string | undefined>>

  createdConvertibleClassEditConvertibleTransactionId: string | undefined
  setCreatedConvertibleClassEditConvertibleTransactionId: Dispatch<
    SetStateAction<string | undefined>
  >

  createdWarrantClassEditWarrantTransactionId: string | undefined
  setCreatedWarrantClassEditWarrantTransactionId: Dispatch<SetStateAction<string | undefined>>

  shareholderFilter: boolean
  setShareholderFilter: Dispatch<SetStateAction<boolean>>

  selectedShareholderTypeFilter: string
  setSelectedShareholderTypeFilter: Dispatch<SetStateAction<string>>

  selectedShareholderSortTypeFilter: string
  setSelectedShareholderSortTypeFilter: Dispatch<SetStateAction<string>>

  activityLogFilter: boolean
  setActivityLogFilter: Dispatch<SetStateAction<boolean>>

  selectedActivityLogTypeFilter: string
  setSelectedActivityLogTypeFilter: Dispatch<SetStateAction<string>>

  securityPermissionFilter: boolean
  setSecurityPermissionFilter: Dispatch<SetStateAction<boolean>>

  selectedSecurityPermissionTypeFilter: string
  setSelectedSecurityPermissionTypeFilter: Dispatch<SetStateAction<string>>

  selectedLevelFilter: boolean
  setSelectedLevelFilter: Dispatch<SetStateAction<boolean>>

  selectedLevelTypeFilter: string
  setSelectedLevelTypeFilter: Dispatch<SetStateAction<string>>

  selectedActionFilter: boolean
  setSelectedActionFilter: Dispatch<SetStateAction<boolean>>

  selectedActionTypeFilter: string
  setSelectedActionTypeFilter: Dispatch<SetStateAction<string>>

  selectedReportFilter: boolean
  setSelectedReportFilter: Dispatch<SetStateAction<boolean>>

  selectedReportTypeFilter: string
  setSelectedReportTypeFilter: Dispatch<SetStateAction<string>>

  selectedScheduleFilter: boolean
  setSelectedScheduleFilter: Dispatch<SetStateAction<boolean>>

  selectedScheduleTypeFilter: string
  setSelectedScheduleTypeFilter: Dispatch<SetStateAction<string>>
}

const initStakeholdersContextPropsState: StakeholdersContextProps = {
  founderPromoterFilter: false,
  setFounderPromoterFilter: () => {},
  selectedFounderPromoterTypeFilter: '',
  setSelectedFounderPromoterTypeFilter: () => {},
  selectedFounderPromoterSortTypeFilter: '',
  setSelectedFounderPromoterSortTypeFilter: () => {},
  teamManagementFilter: false,
  setTeamManagementFilter: () => {},
  selectedTeamManagementTypeFilter: '',
  setSelectedTeamManagementTypeFilter: () => {},
  boardMemberFilter: false,
  setBoardMemberFilter: () => {},
  selectedBoardMemberTypeFilter: '',
  setSelectedBoardMemberTypeFilter: () => {},
  legalCompilanceFilter: false,
  setLegalCompilanceFilter: () => {}, // Typo fix: was setlegalCompilanceFilter
  selectedLegalCompilanceTypeFilter: '', // Typo fix: was selectedlegalCompilanceTypeFilter
  setSelectedLegalCompilanceTypeFilter: () => {},
  selectedLegalCompilanceSortTypeFilter: '', // Typo fix: was selectedlegalCompilanceSortTypeFilter
  setSelectedLegalCompilanceSortTypeFilter: () => {},
  financeAccountsFilter: false,
  setFinanceAccountsFilter: () => {},
  selectedFinanceAccountsTypeFilter: '',
  setSelectedFinanceAccountsTypeFilter: () => {},
  selectedFinanceAccountsSortTypeFilter: '',
  setSelectedFinanceAccountsSortTypeFilter: () => {},
  advisorsMentorsFilter: false,
  setAdvisorsMentorsFilter: () => {},
  selectedAdvisorsMentorsTypeFilter: '',
  setSelectedAdvisorsMentorsTypeFilter: () => {},
  selectedAdvisorsMentorsSortTypeFilter: '',
  setSelectedAdvisorsMentorsSortTypeFilter: () => {},
  shareSecurityClassesSortFilter: false,
  setShareSecurityClassesSortFilter: () => {},
  selectedShareSecurityClassesSortFilter: '',
  setSelectedShareSecurityClassesSortFilter: () => {},

  convertibleSecurityClassesFilter: false,
  setConvertibleSecurityClassesFilter: () => {},

  selectedConvertibleSecurityClassesSortFilter: '',
  setSelectedConvertibleSecurityClassesSortFilter: () => {},

  selectedConvertibleSecurityClassesRateFilter: '',
  setSelectedConvertibleSecurityClassesRateFilter: () => {},

  warrantSecurityClassesFilter: false,
  setWarrantSecurityClassesFilter: () => {},

  selectedWarrantSecurityClassesSortFilter: '',
  setSelectedWarrantSecurityClassesSortFilter: () => {},

  complianceMeetingFilter: false,
  setComplianceMeetingFilter: () => {},

  selectedComplianceMeetingTypeFilter: '',
  setSelectedComplianceMeetingTypeFilter: () => {},

  selectedComplianceMeetingDateFilter: '',
  setSelectedComplianceMeetingDateFilter: () => {},

  shareTransactionFilter: false,
  setShareTransactionFilter: () => {},
  selectedShareTransactionSortFilter: '',
  setSelectedShareTransactionSortFilter: () => {},
  selectedShareTransactionDateFilter: '',
  setSelectedShareTransactionDateFilter: () => {},

  convertibleTransactionFilter: false,
  setConvertibleTransactionFilter: () => {},
  selectedConvertibleTransactionSortFilter: '',
  setSelectedConvertibleTransactionSortFilter: () => {},
  selectedConvertibleTransactionDateFilter: '',
  setSelectedConvertibleTransactionDateFilter: () => {},

  warrantTransactionFilter: false,
  setWarrantTransactionFilter: () => {},
  selectedWarrantTransactionSortFilter: '',
  setSelectedWarrantTransactionSortFilter: () => {},
  selectedWarrantTransactionDateFilter: '',
  setSelectedWarrantTransactionDateFilter: () => {},

  buybackTransactionFilter: false,
  setBuybackTransactionFilter: () => {},
  selectedBuybackTransactionSortFilter: '',
  setSelectedBuybackTransactionSortFilter: () => {},
  selectedBuybackTransactionDateFilter: '',
  setSelectedBuybackTransactionDateFilter: () => {},

  transferTransactionFilter: false,
  setTransferTransactionFilter: () => {},
  selectedTransferTransactionSortFilter: '',
  setSelectedTransferTransactionSortFilter: () => {},
  selectedTransferTransactionDateFilter: '',
  setSelectedTransferTransactionDateFilter: () => {},

  createdShareClassFromOtherClasses: undefined,
  setCreatedShareClassFromOtherClasses: () => {},

  createdShareClassEditConvertibleClassId: undefined,
  setCreatedShareClassEditConvertibleClassId: () => {},

  createdShareClassEditWarrantClassId: undefined,
  setCreatedShareClassEditWarrantClassId: () => {},

  createdConvetibleClassFromOtherTransaction: undefined,
  setCreatedConvetibleClassFromOtherTransaction: () => {},

  createdWarrantClassFromOtherTransaction: undefined,
  setCreatedWarrantClassFromOtherTransaction: () => {},

  createdConvertibleClassEditConvertibleTransactionId: undefined,
  setCreatedConvertibleClassEditConvertibleTransactionId: () => {},

  createdWarrantClassEditWarrantTransactionId: undefined,
  setCreatedWarrantClassEditWarrantTransactionId: () => {},

  shareholderFilter: false,
  setShareholderFilter: () => {},

  selectedShareholderTypeFilter: '',
  setSelectedShareholderTypeFilter: () => {},

  selectedShareholderSortTypeFilter: '',
  setSelectedShareholderSortTypeFilter: () => {},

  activityLogFilter: false,
  setActivityLogFilter: () => {},

  selectedActivityLogTypeFilter: '',
  setSelectedActivityLogTypeFilter: () => {},

  securityPermissionFilter: false,
  setSecurityPermissionFilter: () => {},

  selectedSecurityPermissionTypeFilter: '',
  setSelectedSecurityPermissionTypeFilter: () => {},

  selectedLevelFilter: false,
  setSelectedLevelFilter: () => {},

  selectedLevelTypeFilter: '',
  setSelectedLevelTypeFilter: () => {},

  selectedActionFilter: false,
  setSelectedActionFilter: () => {},

  selectedActionTypeFilter: '',
  setSelectedActionTypeFilter: () => {},

  selectedReportFilter: false,
  setSelectedReportFilter: () => {},

  selectedReportTypeFilter: '',
  setSelectedReportTypeFilter: () => {},

  selectedScheduleFilter: false,
  setSelectedScheduleFilter: () => {},

  selectedScheduleTypeFilter: '',
  setSelectedScheduleTypeFilter: () => {},
}

const StakeholdersContext = createContext<StakeholdersContextProps>(
  initStakeholdersContextPropsState
)

const useStakeholders = () => {
  return useContext(StakeholdersContext)
}

const StakeholdersProvider: FC<WithChildren> = ({children}) => {
  const [founderPromoterFilter, setFounderPromoterFilter] = useState(false)
  const [selectedFounderPromoterTypeFilter, setSelectedFounderPromoterTypeFilter] =
    useState<string>('')
  const [selectedFounderPromoterSortTypeFilter, setSelectedFounderPromoterSortTypeFilter] =
    useState<string>('')
  const [teamManagementFilter, setTeamManagementFilter] = useState(false)
  const [selectedTeamManagementTypeFilter, setSelectedTeamManagementTypeFilter] =
    useState<string>('')
  const [boardMemberFilter, setBoardMemberFilter] = useState(false)
  const [selectedBoardMemberTypeFilter, setSelectedBoardMemberTypeFilter] = useState<string>('')
  const [legalCompilanceFilter, setLegalCompilanceFilter] = useState(false)
  const [selectedLegalCompilanceTypeFilter, setSelectedLegalCompilanceTypeFilter] =
    useState<string>('')
  const [selectedLegalCompilanceSortTypeFilter, setSelectedLegalCompilanceSortTypeFilter] =
    useState<string>('')
  const [financeAccountsFilter, setFinanceAccountsFilter] = useState(false)
  const [selectedFinanceAccountsTypeFilter, setSelectedFinanceAccountsTypeFilter] =
    useState<string>('')
  const [selectedFinanceAccountsSortTypeFilter, setSelectedFinanceAccountsSortTypeFilter] =
    useState<string>('')
  const [advisorsMentorsFilter, setAdvisorsMentorsFilter] = useState(false)
  const [selectedAdvisorsMentorsTypeFilter, setSelectedAdvisorsMentorsTypeFilter] =
    useState<string>('')
  const [selectedAdvisorsMentorsSortTypeFilter, setSelectedAdvisorsMentorsSortTypeFilter] =
    useState<string>('')
  const [shareSecurityClassesSortFilter, setShareSecurityClassesSortFilter] = useState(false)
  const [selectedShareSecurityClassesSortFilter, setSelectedShareSecurityClassesSortFilter] =
    useState<string>('')
  const [convertibleSecurityClassesFilter, setConvertibleSecurityClassesFilter] = useState(false)

  const [
    selectedConvertibleSecurityClassesSortFilter,
    setSelectedConvertibleSecurityClassesSortFilter,
  ] = useState<string>('')
  const [
    selectedConvertibleSecurityClassesRateFilter,
    setSelectedConvertibleSecurityClassesRateFilter,
  ] = useState<string>('')

  const [warrantSecurityClassesFilter, setWarrantSecurityClassesFilter] = useState(false)
  const [selectedWarrantSecurityClassesSortFilter, setSelectedWarrantSecurityClassesSortFilter] =
    useState<string>('')

  const [complianceMeetingFilter, setComplianceMeetingFilter] = useState(false)
  const [selectedComplianceMeetingTypeFilter, setSelectedComplianceMeetingTypeFilter] =
    useState<string>('')
  const [selectedComplianceMeetingDateFilter, setSelectedComplianceMeetingDateFilter] =
    useState<string>('')

  const [shareTransactionFilter, setShareTransactionFilter] = useState(false)
  const [selectedShareTransactionSortFilter, setSelectedShareTransactionSortFilter] =
    useState<string>('')
  const [selectedShareTransactionDateFilter, setSelectedShareTransactionDateFilter] =
    useState<string>('')

  const [convertibleTransactionFilter, setConvertibleTransactionFilter] = useState(false)
  const [selectedConvertibleTransactionSortFilter, setSelectedConvertibleTransactionSortFilter] =
    useState<string>('')
  const [selectedConvertibleTransactionDateFilter, setSelectedConvertibleTransactionDateFilter] =
    useState<string>('')

  const [warrantTransactionFilter, setWarrantTransactionFilter] = useState(false)
  const [selectedWarrantTransactionSortFilter, setSelectedWarrantTransactionSortFilter] =
    useState<string>('')
  const [selectedWarrantTransactionDateFilter, setSelectedWarrantTransactionDateFilter] =
    useState<string>('')

  const [buybackTransactionFilter, setBuybackTransactionFilter] = useState(false)
  const [selectedBuybackTransactionSortFilter, setSelectedBuybackTransactionSortFilter] =
    useState<string>('')
  const [selectedBuybackTransactionDateFilter, setSelectedBuybackTransactionDateFilter] =
    useState<string>('')
  const [transferTransactionFilter, setTransferTransactionFilter] = useState(false)
  const [selectedTransferTransactionSortFilter, setSelectedTransferTransactionSortFilter] =
    useState<string>('')
  const [selectedTransferTransactionDateFilter, setSelectedTransferTransactionDateFilter] =
    useState<string>('')

  const [createdShareClassFromOtherClasses, setCreatedShareClassFromOtherClasses] = useState<
    string | undefined
  >(undefined)

  const [createdShareClassEditConvertibleClassId, setCreatedShareClassEditConvertibleClassId] =
    useState<string | undefined>(undefined)

  const [createdShareClassEditWarrantClassId, setCreatedShareClassEditWarrantClassId] = useState<
    string | undefined
  >(undefined)

  const [
    createdConvetibleClassFromOtherTransaction,
    setCreatedConvetibleClassFromOtherTransaction,
  ] = useState<string | undefined>(undefined)
  const [createdWarrantClassFromOtherTransaction, setCreatedWarrantClassFromOtherTransaction] =
    useState<string | undefined>(undefined)
  const [
    createdConvertibleClassEditConvertibleTransactionId,
    setCreatedConvertibleClassEditConvertibleTransactionId,
  ] = useState<string | undefined>(undefined)
  const [
    createdWarrantClassEditWarrantTransactionId,
    setCreatedWarrantClassEditWarrantTransactionId,
  ] = useState<string | undefined>(undefined)

  const [shareholderFilter, setShareholderFilter] = useState(false)
  const [selectedShareholderTypeFilter, setSelectedShareholderTypeFilter] = useState<string>('')
  const [selectedShareholderSortTypeFilter, setSelectedShareholderSortTypeFilter] =
    useState<string>('')
  const [activityLogFilter, setActivityLogFilter] = useState<boolean>(false)
  const [selectedActivityLogTypeFilter, setSelectedActivityLogTypeFilter] = useState<string>('')
  const [securityPermissionFilter, setSecurityPermissionFilter] = useState<boolean>(false)
  const [selectedSecurityPermissionTypeFilter, setSelectedSecurityPermissionTypeFilter] =
    useState<string>('')

  const [selectedLevelFilter, setSelectedLevelFilter] = useState<boolean>(false)
  const [selectedLevelTypeFilter, setSelectedLevelTypeFilter] = useState<string>('')
  const [selectedActionFilter, setSelectedActionFilter] = useState<boolean>(false)
  const [selectedActionTypeFilter, setSelectedActionTypeFilter] = useState<string>('')
  const [selectedReportFilter, setSelectedReportFilter] = useState<boolean>(false)
  const [selectedReportTypeFilter, setSelectedReportTypeFilter] = useState<string>('')
  const [selectedScheduleFilter, setSelectedScheduleFilter] = useState<boolean>(false)
  const [selectedScheduleTypeFilter, setSelectedScheduleTypeFilter] = useState<string>('')

  return (
    <StakeholdersContext.Provider
      value={{
        founderPromoterFilter,
        setFounderPromoterFilter,
        selectedFounderPromoterTypeFilter,
        setSelectedFounderPromoterTypeFilter,
        selectedFounderPromoterSortTypeFilter,
        setSelectedFounderPromoterSortTypeFilter,
        teamManagementFilter,
        setTeamManagementFilter,
        selectedTeamManagementTypeFilter,
        setSelectedTeamManagementTypeFilter,
        boardMemberFilter,
        setBoardMemberFilter,
        selectedBoardMemberTypeFilter,
        setSelectedBoardMemberTypeFilter,
        legalCompilanceFilter,
        setLegalCompilanceFilter,
        selectedLegalCompilanceTypeFilter,
        setSelectedLegalCompilanceTypeFilter,
        selectedLegalCompilanceSortTypeFilter,
        setSelectedLegalCompilanceSortTypeFilter,
        financeAccountsFilter,
        setFinanceAccountsFilter,
        selectedFinanceAccountsTypeFilter,
        setSelectedFinanceAccountsTypeFilter,
        selectedFinanceAccountsSortTypeFilter,
        setSelectedFinanceAccountsSortTypeFilter,
        advisorsMentorsFilter,
        setAdvisorsMentorsFilter,
        selectedAdvisorsMentorsTypeFilter,
        setSelectedAdvisorsMentorsTypeFilter,
        selectedAdvisorsMentorsSortTypeFilter,
        setSelectedAdvisorsMentorsSortTypeFilter,
        shareSecurityClassesSortFilter,
        setShareSecurityClassesSortFilter,
        selectedShareSecurityClassesSortFilter,
        setSelectedShareSecurityClassesSortFilter,
        convertibleSecurityClassesFilter,
        setConvertibleSecurityClassesFilter,
        selectedConvertibleSecurityClassesSortFilter,
        setSelectedConvertibleSecurityClassesSortFilter,
        selectedConvertibleSecurityClassesRateFilter,
        setSelectedConvertibleSecurityClassesRateFilter,
        warrantSecurityClassesFilter,
        setWarrantSecurityClassesFilter,
        selectedWarrantSecurityClassesSortFilter,
        setSelectedWarrantSecurityClassesSortFilter,
        complianceMeetingFilter,
        setComplianceMeetingFilter,
        selectedComplianceMeetingTypeFilter,
        setSelectedComplianceMeetingTypeFilter,
        selectedComplianceMeetingDateFilter,
        setSelectedComplianceMeetingDateFilter,
        shareTransactionFilter,
        setShareTransactionFilter,
        selectedShareTransactionSortFilter,
        setSelectedShareTransactionSortFilter,
        selectedShareTransactionDateFilter,
        setSelectedShareTransactionDateFilter,
        convertibleTransactionFilter,
        setConvertibleTransactionFilter,
        selectedConvertibleTransactionSortFilter,
        setSelectedConvertibleTransactionSortFilter,
        selectedConvertibleTransactionDateFilter,
        setSelectedConvertibleTransactionDateFilter,
        warrantTransactionFilter,
        setWarrantTransactionFilter,
        selectedWarrantTransactionSortFilter,
        setSelectedWarrantTransactionSortFilter,
        selectedWarrantTransactionDateFilter,
        setSelectedWarrantTransactionDateFilter,
        buybackTransactionFilter,
        setBuybackTransactionFilter,
        selectedBuybackTransactionSortFilter,
        setSelectedBuybackTransactionSortFilter,
        selectedBuybackTransactionDateFilter,
        setSelectedBuybackTransactionDateFilter,
        transferTransactionFilter,
        setTransferTransactionFilter,
        selectedTransferTransactionSortFilter,
        setSelectedTransferTransactionSortFilter,
        selectedTransferTransactionDateFilter,
        setSelectedTransferTransactionDateFilter,
        createdShareClassFromOtherClasses,
        setCreatedShareClassFromOtherClasses,
        createdShareClassEditConvertibleClassId,
        setCreatedShareClassEditConvertibleClassId,
        createdShareClassEditWarrantClassId,
        setCreatedShareClassEditWarrantClassId,
        createdConvetibleClassFromOtherTransaction,
        setCreatedConvetibleClassFromOtherTransaction,
        createdWarrantClassFromOtherTransaction,
        setCreatedWarrantClassFromOtherTransaction,
        createdConvertibleClassEditConvertibleTransactionId,
        setCreatedConvertibleClassEditConvertibleTransactionId,
        createdWarrantClassEditWarrantTransactionId,
        setCreatedWarrantClassEditWarrantTransactionId,
        shareholderFilter,
        setShareholderFilter,
        selectedShareholderTypeFilter,
        setSelectedShareholderTypeFilter,
        selectedShareholderSortTypeFilter,
        setSelectedShareholderSortTypeFilter,
        activityLogFilter,
        setActivityLogFilter,
        selectedActivityLogTypeFilter,
        setSelectedActivityLogTypeFilter,
        securityPermissionFilter,
        setSecurityPermissionFilter,
        selectedSecurityPermissionTypeFilter,
        setSelectedSecurityPermissionTypeFilter,
        selectedLevelFilter,
        setSelectedLevelFilter,
        selectedActionTypeFilter,
        setSelectedActionTypeFilter,
        selectedLevelTypeFilter,
        setSelectedLevelTypeFilter,
        selectedActionFilter,
        setSelectedActionFilter,
        selectedReportFilter,
        setSelectedReportFilter,
        selectedReportTypeFilter,
        setSelectedReportTypeFilter,
        selectedScheduleFilter,
        setSelectedScheduleFilter,
        selectedScheduleTypeFilter,
        setSelectedScheduleTypeFilter,
      }}
    >
      {children}
    </StakeholdersContext.Provider>
  )
}

export {StakeholdersProvider, useStakeholders}
